import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7l6 -3l6 3l6 -3v13l-6 3l-6 -3l-6 3v-13","key":"svg-0"}],["path",{"d":"M9 12v.01","key":"svg-1"}],["path",{"d":"M6 13v.01","key":"svg-2"}],["path",{"d":"M17 15l-4 -4","key":"svg-3"}],["path",{"d":"M13 15l4 -4","key":"svg-4"}]]

const IconMapRoute = createReactComponent('outline', 'map-route', 'MapRoute', __iconNode);

export default IconMapRoute;